import styled from 'styled-components';
import { COLORS, FONTS, SIZE } from '@app/src/ui';

const ROOT = 'StepConfirm/sectionConfirm/TitleConfirmOpportunity';

export const TitleWrapper = styled.h2`
  font-family: ${FONTS.ARISTOTELICA};
  font-size: 22px;
  color: ${COLORS.BLACK};
  text-align: center;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 30px;
  }
`;

TitleWrapper.className = `${ROOT}/TitleWrapper`;

export const Image = styled.img`
  margin: 5% auto 15px;
  width: 205px;
`;

Image.className = `${ROOT}/Image`;
